import { useState } from "react"
import styled from "styled-components"

import SubscriptionPrivilege from "types/enums/SubscriptionPrivilege"

import { SubscriptionUpgradeModal } from "modals/SubscriptionUpgradeModal/SubscriptionUpgradeModal"
import { ButtonNew } from "components/form/ButtonNew"

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 120px;
`

const BlurredContent = styled.div<{ $blur: boolean }>`
  filter: ${({ $blur }) => ($blur ? "blur(4px)" : "none")};
  pointer-events: ${({ $blur }) => ($blur ? "none" : "auto")};
`

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 24px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(4px);
  border-radius: 20px;
`

const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
  text-align: center;
`

const Subtitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #64748b;
  margin: 0;
  text-align: center;
  line-height: 1.4;
  max-width: 280px;
`

interface ChartUnavailableOverlayProps {
  isUnsupported: boolean
  privilege?: SubscriptionPrivilege
  children: React.ReactNode
}

export const ChartUnavailableOverlay = ({
  isUnsupported,
  privilege = SubscriptionPrivilege.PerformanceTest,
  children,
}: ChartUnavailableOverlayProps) => {
  const [showUpgradeModal, setShowUpgradeModal] = useState(false)

  if (!isUnsupported) {
    return <>{children}</>
  }

  return (
    <Wrapper>
      <BlurredContent $blur={isUnsupported}>{children}</BlurredContent>
      <Overlay>
        <Title>The Chart is Unavailable</Title>
        <Subtitle>The chart isn&apos;t available in your current plan. Upgrade your plan to unlock access.</Subtitle>
        <ButtonNew onClick={() => setShowUpgradeModal(true)} size="auto" color="blueBordered">
          View Plans
        </ButtonNew>
      </Overlay>
      {showUpgradeModal && (
        <SubscriptionUpgradeModal page={privilege} hideUnavailableModal onCancel={() => setShowUpgradeModal(false)} />
      )}
    </Wrapper>
  )
}
